export default __webpack_public_path__ + "static/media/Icon-AI-Scanner-Hashtag.5f48712d.svg";